import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { CompanySetupCheckoutComponent } from './company-setup-checkout/company-setup-checkout.component';
import { CompanySetupPlanComponent } from './company-setup-plan/company-setup-plan.component';
import { CompanySetupSigninComponent } from './company-setup-signin/company-setup-signin.component';
import { CompanySetupService } from './company-setup.service';
@Component({
  selector: 'app-company-setup',
  templateUrl: './company-setup.component.html',
  styleUrls: ['./company-setup.component.scss'],
})
export class CompanySetupComponent implements OnInit, OnDestroy {
  components = [
    {
      component: CompanySetupSigninComponent,
      header: {
        title: 'Preencha com os dados da sua empresa',
        isDarkBackground: true,
        isTitleCenter: false,
      },
    },
    {
      component: CompanySetupPlanComponent,
      header: {
        title: 'Selecione o plano que deseja para sua empresa:',
        isDarkBackground: true,
        isTitleCenter: true,
      },
    },
    {
      component: CompanySetupCheckoutComponent,
      header: {
        title:
          'Confira os dados da sua campanha e realize o pagamento para concluir:',
        isDarkBackground: false,
        isTitleCenter: false,
      },
    },
  ];

  currentComponentIndex: number = 0;
  onDestroy$ = new Subject<void>();

  constructor(
    public router: Router,
    private companySetupService: CompanySetupService
  ) {}

  ngOnInit(): void {
    this.companySetupService.currentComponentIndex
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((index: number) => (this.currentComponentIndex = index));
  }

  close() {
    if (this.currentComponentIndex > 0) {
      // Volta uma etapa dentro do fluxo (plano → dados, checkout → plano)
      this.companySetupService.currentComponentIndex.next(this.currentComponentIndex - 1);
    } else {
      // Etapa 0 (dados da empresa) → retorna para seleção de contexto
      this.router.navigate(['/access/context']);
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
